import React from "react";
import { Form, Input, Button } from "antd";
import "./InfoBox.scss";

import consultTitle from "../../images/checkAssistant/小工具02_彈跳視窗icon.png";

const InfoBox = ({
  currentContentIndex,
  onClose,
  isLoading,
  handleSubmit,
  nextContent,
}) => {
  return (
    <div className="info-box">
      {/* Loading 顯示區塊 */}
      {isLoading && (
        <div className="loading-overlay">
          <span className="loading-spinner"></span>
        </div>
      )}

      {/* 關閉按鈕 */}
      <button className="close-button" onClick={onClose}>
        &times;
      </button>

      {/* 第一個內容 */}
      {currentContentIndex === 0 && (
        <div className="step1">
          <h3>
            <img src={consultTitle} alt="Icon" />
            需要專屬的數據優化方案嗎？
          </h3>
          <ul>
            <li>擺脫 GA4 數據延遲，即時檢視數據表現</li>
            <li>了解競業各項數據指標與排名分析</li>
            <li>客製化提升轉換率/營收優化方案</li>
          </ul>
          <button className="cta-button" onClick={nextContent}>
            立即了解服務
          </button>
        </div>
      )}

      {/* 第二個內容 - 表單 */}
      {currentContentIndex === 1 && (
        <div className="step2">
          <h3>
            <img src={consultTitle} alt="Icon" />
            需要專屬的數據優化方案嗎？
          </h3>
          <ul>
            <li>擺脫 GA4 數據延遲，即時檢視數據表現</li>
            <li>了解競業各項數據指標與排名分析</li>
            <li>客製化提升轉換率/營收優化方案</li>
          </ul>
          <Form
            name="consult_form"
            layout="horizontal"
            autoComplete="off"
            onFinish={handleSubmit} // 表單提交後切換到第三個內容
          >
            <Form.Item
              label={<span>聯絡姓名</span>}
              name="name"
              rules={[{ required: true, message: "請輸入姓名！" }]}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input placeholder="請輸入您的姓名" />
            </Form.Item>
            <Form.Item
              label={<span>聯絡電話</span>}
              name="phone"
              rules={[
                { required: true, message: "請輸入電話！" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "電話號碼格式不正確！",
                },
              ]}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input placeholder="請輸入您的電話" />
            </Form.Item>
            <Form.Item
              label={<span>聯絡信箱</span>}
              name="email"
              rules={[
                { required: true, message: "請輸入信箱！" },
                { type: "email", message: "信箱格式不正確！" },
              ]}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input placeholder="請輸入您的信箱" />
            </Form.Item>
            <Form.Item style={{ marginBottom: "0" }}>
              <Button type="primary" htmlType="submit">
                立即開始諮詢
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}

      {/* 第三個內容 */}
      {currentContentIndex === 2 && (
        <div className="step3">
          <h3>
            感謝您提交表單，
            <br />
            我們的專員將於工作日儘速聯繫您。
          </h3>
          <div className="service">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://lihi2.com/eR2km"
              style={{ color: "#1890ff" }}
            >
              [前往官網]
            </a>
            ，了解更多圖靈數位服務
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoBox;
